import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-image-preview-modal',
    templateUrl: './image-preview-modal.component.html',
    styleUrl: './image-preview-modal.component.scss'
})
export class ImagePreviewModalComponent {
  @Input() imageUrl!: string;
  @Input() filename!: string;

  constructor(public activeModal: NgbActiveModal) {}
}